import { Suspense, lazy } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";

import Login from "./pages/Login";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import Notification from "./components/Notification";
import Popup from "./components/Popup";

// Lazy loading pages (AppLayout is also lazy loaded now to reduce bundle size)
const Signup = lazy(() => import("./pages/Signup"));
const AppLayoutLazy = lazy(() => import("./layouts/AppLayout"));
const Home = lazy(() => import("./pages/Home"));
const Cases = lazy(() => import("./pages/Cases"));
const HistoricalVault = lazy(() => import("./pages/HistoricalVault"));
const CaseDetails = lazy(() => import("./pages/CaseDetails"));
const Documents = lazy(() => import("./pages/Documents"));
const Petition = lazy(() => import("./pages/Petition"));
const Settings = lazy(() => import("./pages/Settings"));
const Admin = lazy(() => import("./pages/Admin"));
const HistoricalCaseView = lazy(() => import("./pages/HistoricalCaseView"));
const InvoiceManagement = lazy(() => import("./pages/InvoiceManagement"));
const ContractReview = lazy(() => import("./pages/ContractReview"));

export default function App() {
  return (
    <>
      <Notification />
      <Popup />
      <BrowserRouter>
        <Suspense fallback={
          <div style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100vh',
            fontSize: '1.2rem',
            color: '#666'
          }}>
            Loading...
          </div>
        }>
          <Routes>
            {/* AUTH ROUTES (NO SIDEBAR) */}
            <Route path="/" element={<Login />} />
            <Route path="/signup" element={<Signup />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />

            {/* APP ROUTES (WITH SIDEBAR) */}
            <Route
              path="/home"
              element={
                <AppLayoutLazy>
                  <Home />
                </AppLayoutLazy>
              }
            />

            <Route
              path="/cases"
              element={
                <AppLayoutLazy>
                  <Cases />
                </AppLayoutLazy>
              }
            />

            <Route
              path="/historical-vault"
              element={
                <AppLayoutLazy>
                  <HistoricalVault />
                </AppLayoutLazy>
              }
            />

            <Route
              path="/historical-vault/case/:id"
              element={
                <AppLayoutLazy>
                  <HistoricalCaseView />
                </AppLayoutLazy>
              }
            />

            <Route
              path="/cases/:id"
              element={
                <AppLayoutLazy>
                  <CaseDetails />
                </AppLayoutLazy>
              }
            />

            <Route
              path="/cases/:id/documents"
              element={
                <AppLayoutLazy>
                  <Documents />
                </AppLayoutLazy>
              }
            />

            <Route
              path="/cases/:id/documents/petition"
              element={
                <AppLayoutLazy>
                  <Petition />
                </AppLayoutLazy>
              }
            />

            <Route
              path="/settings"
              element={
                <AppLayoutLazy>
                  <Settings />
                </AppLayoutLazy>
              }
            />

            <Route
              path="/admin"
              element={
                <AppLayoutLazy>
                  <Admin />
                </AppLayoutLazy>
              }
            />

            <Route
              path="/invoice-management"
              element={
                <AppLayoutLazy>
                  <InvoiceManagement />
                </AppLayoutLazy>
              }
            />

            <Route
              path="/Contract-review"
              element={
                <AppLayoutLazy>
                  <ContractReview />
                </AppLayoutLazy>
              }
            />

          </Routes>
        </Suspense>
      </BrowserRouter>
    </>
  );
}